import { useQuery } from "@apollo/react-hooks";

import { Learner } from "@hubcapp/types";

import LearnerDetailsModalDataQuery from "../graph-ql/getLearnerDetailsModalData.graphql";

const useQueryLearnerDetailsModal = (id?: string) =>
  useQuery<{ learner: Learner }>(LearnerDetailsModalDataQuery, {
    variables: {
      id,
    },
    skip: !id,
  });

export default useQueryLearnerDetailsModal;
